// Internal Imports
import { API_ENDPOINTS, DATA_PLAYFIELD } from "../../constants";
import { GlobalUtils } from "../../utils";

// Service Imports
import { fetchFlagConfig } from "../CommonActions/commonService";

// Destructuring
const { APIS } = API_ENDPOINTS;
const { CRM_SHORT_NAMES: crmIds } = DATA_PLAYFIELD;
const { readDataFromLocalStorage } = GlobalUtils;

// eslint-disable-next-line import/prefer-default-export
export const getCRMAuthURl = (crmConfig, orgID) => {
  const {
    client_id: clientID,
    client_secret: clientSecret,
    crm: crmID,
    redirect_url: redirectURL,
    is_sandbox: isSandbox,
    scopes,
  } = crmConfig;
  switch (crmID) {
    case crmIds.SALESFORCE: {
      const apiUrl = isSandbox ? APIS.SF_TEST_OAUTH2 : APIS.SF_LOGIN_OAUTH2;
      return `${apiUrl}?response_type=code&client_id=${clientID}&client_secret=${clientSecret}&redirect_uri=${redirectURL}&state=${orgID}&
    scope=full%20refresh_token`;
    }

    case crmIds.HUBSPOT: {
      // TODO: use scopes & create a new url
      return `https://app.hubspot.com/oauth/authorize?client_id=${clientID}&scope=${scopes}&redirect_uri=${redirectURL}`;
      // return scopes;
    }
    case crmIds.ZOHO:
      return `${APIS.ZH_OAUTH2}&client_id=${clientID}&response_type=code&access_type=offline&prompt=consent&redirect_uri=${redirectURL}&state=${orgID}`;
    case crmIds.DOCUSIGN:
      return `${APIS.DOC_SIGN}&client_id=${clientID}&redirect_uri=${crmConfig.redirectURL}`;
    case crmIds.BOX:
      return `${APIS.BOX_AUTH}&client_id=${clientID}&redirect_uri=${redirectURL}&client_secret=${clientSecret}`;
    default:
      return null;
  }
};

// do not make this function async
export const isBoxSign = () => {
  const appFlag = readDataFromLocalStorage("appFlag");
  if (appFlag && appFlag.esign_type && appFlag.esign_type === "BOX") {
    return true;
  }
  return false;
};

export const isBoxEsignFlowEnabled = async () => {
  // Check if org has box esign flow
  const appFlag = readDataFromLocalStorage("appFlag");

  if (appFlag && appFlag.esign_type && appFlag.esign_type === "BOX") {
    return true;
  }

  // If esign type org flag is not present, make api call to get the updated list
  if (appFlag && !appFlag.esign_type) {
    const flag = await fetchFlagConfig();
    console.debug(flag);
    const updatedAppFlag = readDataFromLocalStorage("appFlag");
    if (
      updatedAppFlag &&
      updatedAppFlag.esign_type &&
      updatedAppFlag.esign_type === "BOX"
    ) {
      return true;
    }
    return false;
  }
  return false;
};
